/* eslint-disable react-hooks/exhaustive-deps */
import {
  Input,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  VStack,
} from '@chakra-ui/react'
import React, { useEffect, useState } from 'react'
import { useLanguageContext } from '../../../../../context/locale.context'
import { useSmartFormContext } from '../../../../../context/smart-form.context'
import {
  useLoadProductCategories,
  useLoadProductVariants,
  useLoadProductWorkflow,
  useLoadProductWorkflowTypes,
} from '../../../../../hooks/form.hooks'
import { smartFormConst } from '../../../../../utils/action.constant'
import {
  getAddToCurrentDateUTC,
  getCurrentDateUTC,
} from '../../../../../utils/date.utils'
import {
  loadFinalValue,
  prepareFinalFieldValueForEdit,
} from '../../../../../utils/form.util'
import Select from '../../../../chakra-react-select'
import './style.scss'
/**
 * dataTypeID 71
 * dataTypeName  Product Cart
 *
 */
const ProductCartField = ({
  field,
  isRequired,
  isDisabled = true,
  onValidate,
  isBulkEdit,
  fieldIndex,
  ...rest
}) => {
  const {
    state: { fields: formFields },
    dispatch,
  } = useSmartFormContext()
  const {
    state: { locale },
  } = useLanguageContext()
  const fields = !!formFields[field.form_id] ? formFields[field.form_id] : {}
  // console.log(fields, 'fields');
  const { field_id } = field

  const { mutate: mutateProductCategories, data: productCategories } =
    useLoadProductCategories()
  const { mutate: mutateProductWorkflow, data: productWorkflows } =
    useLoadProductWorkflow()
  const { mutate: mutateProductWorkflowTypes, data: productWorkflowTypes } =
    useLoadProductWorkflowTypes()
  const { mutate: mutateProductVariants, data: productVariants } =
    useLoadProductVariants()

  const [fromEdit, setFromEdit] = useState(false)
  const [isfromEdit, setIsFromEdit] = useState(false)
  const [productCat, setproductCat] = useState(null)
  const [productWorkflowType, setproductWorkflowType] = useState(null)
  const [productWorkflow, setproductWorkflow] = useState(null)
  const [productVariant, setproductVariant] = useState([])
  const [productTotal, setProductTotal] = useState(0)

  // useEffect(() => {
  //   if (!!productCatData) {
  //     setproductCat(productCatData);
  //   }
  //   if (!!productWorkflowData) {
  //     setproductWorkflow(productWorkflowData);
  //   }
  //   if (!!productWorkflowTypeData) {
  //     setproductWorkflowType(productWorkflowTypeData);
  //   }
  //   if (!!productVariantData) {
  //     setproductVariant(productVariantData);
  //   }
  //   if (!!productTotalData) {
  //     setProductTotal(productTotalData);
  //   }
  // });

  useEffect(() => {
    mutateProductCategories({})
  }, [mutateProductCategories])

  useEffect(() => {
    if (
      !!fields[field_id] &&
      !!fields[field_id].field_value &&
      !!fields[field_id].field_value.isFromEdit
    ) {
      const {
        productCatData,
        productWorkflowData,
        productWorkflowTypeData,
        productVariantData,
        productTotalData,
        isFromEdit,
      } = fields[field_id].field_value
      if (!!productCatData && isFromEdit) {
        setFromEdit(isFromEdit)
        setIsFromEdit(isFromEdit)
        setproductCat(productCatData)
        setproductWorkflowType(productWorkflowTypeData)
        setproductWorkflow(productWorkflowData)
        setproductVariant(productVariantData)
        setProductTotal(productTotalData)
        onValidate(true)
        const { value } = productWorkflowData
        mutateProductVariants({
          parent_activity_id: value,
          flag: 1,
          sort_flag: 1,
          datetime_start: getCurrentDateUTC(),
          datetime_end: getAddToCurrentDateUTC(),
          start_from: 0,
          limit_value: 50,
        })
      }
    }
  }, [isfromEdit])

  useEffect(() => {
    if (
      !!fields[field_id] &&
      !!fields[field_id].field_value &&
      !!fields[field_id].field_value.isFromEdit
    ) {
      const {
        productCatData,
        productWorkflowData,
        productWorkflowTypeData,
        productVariantData,
        productTotalData,
        isFromEdit,
      } = fields[field_id].field_value

      if (!!productCatData && isFromEdit) {
        setFromEdit(isFromEdit)
        setIsFromEdit(isFromEdit)
        setproductCat(productCatData)
        setproductWorkflowType(productWorkflowTypeData)
        setproductWorkflow(productWorkflowData)
        setproductVariant(productVariantData)
        setProductTotal(productTotalData)
        onValidate(true)
      }
    }
  }, [fields[field_id]])

  useEffect(() => {
    if (!!productCat && !fromEdit) {
      onValidate(false)
      setproductWorkflowType(null)
      setproductWorkflow(null)
      setproductVariant([])
      mutateProductWorkflowTypes({
        tag_id: productCat.value,
      })
      mutateProductWorkflow({})
      mutateProductVariants({})
    }
  }, [productCat])

  useEffect(() => {
    if (!!productWorkflowType && !fromEdit) {
      onValidate(false)
      setproductWorkflow(null)
      setproductVariant([])
      const { details, value } = productWorkflowType
      const { activity_type_category_id, tag_id, tag_type_id } = details
      mutateProductWorkflow({
        activity_type_category_id,
        activity_type_id: value,
        flag: 0,
        tag_id,
        tag_type_id,
        search_string: '',
        flag_status: 0,
        flag_participating: 2,
        start_from: 0,
        limit_value: 50,
      })
      mutateProductVariants({})
    }
  }, [productWorkflowType])

  useEffect(() => {
    if (!!productWorkflow && !fromEdit) {
      onValidate(false)
      setproductVariant([])
      const { details, value } = productWorkflow
      const {
        activity_datetime_start_expected,
        activity_datetime_end_deferred,
      } = details
      mutateProductVariants({
        parent_activity_id: value,
        flag: 1,
        sort_flag: 1,
        datetime_start: getCurrentDateUTC(activity_datetime_start_expected),
        datetime_end: getAddToCurrentDateUTC(activity_datetime_end_deferred),
        start_from: 0,
        limit_value: 50,
      })
    }
  }, [productWorkflow])

  useEffect(() => {
    if (productVariant && productVariant.length > 0 && !fromEdit) {
      let total = productVariant.reduce(
        (s, f) => (!!f.productPrice ? s + Number(f.productPrice) : s + 0),
        0
      )
      setProductTotal(total)
    } else if (!fromEdit) {
      setProductTotal(null)
      onValidate(false)
    }
  }, [productVariant])

  useEffect(() => {
    const isVarSet = !!productVariant.map(i => i.quantity).filter(Boolean)
      .length
    if (
      productTotal > -1 &&
      isVarSet &&
      productVariant.length > 0 &&
      !fromEdit
    ) {
      onValidate(true)
      prepareFinalFieldValueForEdit(
        loadFinalValue(field, {
          productVariant,
          productTotal,
          productWorkflow,
          productCat,
          productWorkflowType,
        }).final
      )
      dispatch({
        type: smartFormConst.SET_FIELD_VALUE,
        fieldId: field.field_id,
        formId: field.form_id,
        value: loadFinalValue(field, {
          productVariant,
          productTotal,
          productWorkflow,
          productCat,
          productWorkflowType,
        }),
      })
      dispatch({
        type: smartFormConst.TO_REFRESH_NUM_VAL,
      })
    } else if (!fromEdit) {
      onValidate(false)
    }
  }, [productTotal, productVariant])

  const onPriceChange = (e, option) => {
    let variants = [...productVariant]

    let vPrice = e.target.value * Number(option.quantity)
    let vIndex = productVariant.findIndex(
      v => Number(v.value) === Number(option.value)
    )
    variants[vIndex].details.activity_cuid_3 = e.target.value
    variants[vIndex] = {
      ...variants[vIndex],
      productPrice: vPrice,
      quantity: option.quantity,
    }
    setFromEdit(false)
    setproductVariant(variants)
  }

  const onQntyChange = (e, option) => {
    let variants = [...productVariant]
    let variantPrice = e.target.value * Number(option.details.activity_cuid_3)
    let vIndex = productVariant.findIndex(
      v => Number(v.value) === Number(option.value)
    )
    if (vIndex > -1) {
      variants[vIndex] = {
        ...variants[vIndex],
        productPrice: variantPrice,
        quantity: e.target.value,
      }
    } else {
      variants.push({
        ...option,
        productPrice: variantPrice,
        quantity: e.target.value,
      })
    }
    setFromEdit(false)
    setproductVariant(variants)
  }

  return (
    <VStack spacing={2} w="full">
      <Select
        className="full-width"
        name={field.field_id}
        id={`${field.field_name.split(' ').join('-')}-category`}
        isDisabled={(isDisabled || isfromEdit) && !isBulkEdit}
        options={productCategories || []}
        placeholder="Select product category"
        borderRadius="md"
        size="sm"
        value={productCat}
        // menuPlacement={fieldIndex > 0 ? 'top' : 'bottom'}
        onChange={e => {
          setproductCat(e)
          setFromEdit(false)
        }}
      />
      <Select
        className="full-width"
        name={field.field_id}
        id={`${field.field_name.split(' ').join('-')}-product-types`}
        isDisabled={(isDisabled || isfromEdit) && !isBulkEdit}
        options={productWorkflowTypes || []}
        placeholder="Select product types"
        borderRadius="md"
        size="sm"
        value={productWorkflowType}
        onChange={setproductWorkflowType}
        // menuPlacement={fieldIndex > 0 ? 'top' : 'bottom'}
      />
      <Select
        className="full-width"
        name={field.field_id}
        id={`${field.field_name.split(' ').join('-')}-product`}
        isDisabled={(isDisabled || isfromEdit) && !isBulkEdit}
        options={productWorkflows || []}
        placeholder="Select product"
        borderRadius="md"
        size="sm"
        value={productWorkflow}
        onChange={setproductWorkflow}
        // menuPlacement={fieldIndex > 0 ? 'top' : 'bottom'}
      />
      <Select
        isMulti={true}
        className="full-width"
        name={field.field_id}
        id={`${field.field_name.split(' ').join('-')}-variants`}
        isDisabled={isDisabled}
        options={
          !!productWorkflow
            ? productVariants || [
                {
                  details: {
                    activity_cuid_2: null,
                    activity_cuid_3: null,
                  },
                  label: 'Custom variant',
                  value: '',
                },
              ]
            : []
        }
        // menuPlacement={fieldIndex > 0 ? 'top' : 'bottom'}
        placeholder="Select product variants"
        borderRadius="md"
        size="sm"
        value={productVariant}
        onChange={e => {
          //setproductVariant(unionBy(e, productVariant, 'label'));
          setproductVariant(e)
          setFromEdit(false)
        }}
      />
      {!!productVariant && productVariant.length > 0 ? (
        <Table w="full">
          <Thead position={'relative'} zIndex={1}>
            <Tr>
              <Th>{locale['Variant Name']}</Th>
              <Th>{locale['Quantity']}</Th>
              <Th>{locale['Monthly Price']}</Th>
            </Tr>
          </Thead>
          <Tbody>
            {productVariant.map((p, index) => {
              return (
                <Tr key={index}>
                  <Td>{p.label}</Td>
                  <Td>
                    <Input
                      size="sm"
                      borderRadius="sm"
                      type="number"
                      min={0}
                      value={p.quantity ? p.quantity : ''}
                      onChange={e => onQntyChange(e, p)}
                      disabled={isDisabled}
                    />
                  </Td>
                  {p.value === 0 ? (
                    <Td>
                      <Input
                        size="sm"
                        borderRadius="sm"
                        type="number"
                        min={0}
                        value={p.details.activity_cuid_3}
                        onChange={e => onPriceChange(e, p)}
                        disabled={isDisabled}
                      />
                    </Td>
                  ) : (
                    <Td>{p.details.activity_cuid_3}</Td>
                  )}
                </Tr>
              )
            })}
            <Tr>
              <Td>{locale['Total Monthly Cart Value']} </Td>
              <Td></Td>
              <Td>{Number(productTotal)}</Td>
            </Tr>
          </Tbody>
        </Table>
      ) : null}
    </VStack>
  )
}

export default ProductCartField
